import React from "react";
import { Text, Box } from '@mantine/core';

import InputWrapperCustom from "../general/InputWrapperCustom";
import PrioritySelectorSingle from "../general/PrioritySelectorSingle";

const PriorityNotaDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={<Text>{stateData.data.label}</Text>}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                <Box mt='sm'>
                    <PrioritySelectorSingle
                        stateValue={stateData.data.value}
                        fnOnChange={() => { }}
                    />
                </Box>
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default PriorityNotaDibatalkan;